import { connect } from 'react-redux'
import {
  setAvailableProjectTags,
  setProjectTags,
  createNewProjectTag,
  resetCreateProjectTagStatusMessages,
  types,
} from '../../../../actions/projects/form_actions'
import { createLoadingSelector } from '../../../../libs/requests_status_handlers'

const loadingSelector = createLoadingSelector([types.CREATE_NEW_PROJECT_TAG, types.CREATE_NEW_FINANCE_TAG])

export default connect(
  (state: any) => ({
    availableProjectTags: state.projects?.form?.availableProjectTags || [],
    projectTags: state.projects?.form?.projectTags || [],
    isFetching: loadingSelector(state),
    createProjectTagError: state.projects?.form?.createProjectTag?.error,
    createProjectTagSuccess: state.projects?.form?.createProjectTag?.success,
  }),
  {
    setAvailableProjectTags,
    setProjectTags,
    createNewProjectTag,
    resetCreateProjectTagStatusMessages,
  }
)
